import { ElementType, ReactNode } from "react";
import { useInView } from "@/hooks/useInView";

type RevealProps = {
  children: ReactNode;
  /** Verzögerung in Millisekunden für gestaffelte Abfolgen. */
  delay?: number;
  className?: string;
  as?: ElementType;
};

/**
 * Ruhiges Einblenden beim Scrollen: Deckkraft plus 12px Aufwärtsbewegung.
 * Ohne Bewegung, wenn der Nutzer reduzierte Bewegung wünscht.
 */
export function Reveal({ children, delay = 0, className = "", as }: RevealProps) {
  const Tag = (as ?? "div") as ElementType;
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? "is-visible" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
}
